module.exports = __webpack_public_path__ + "static/media/financeiro-icon.ce92bad1.svg";